var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-status",class:_vm.iconPosition},[_c('div',{class:_vm.status.value},[_vm._v(_vm._s(_vm.$t(_vm.status.label)))]),_c(_vm.computedIcon,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }